import React from 'react';

interface INoDataInList {
    heading?: string;
    description?: string;
}
const NoDataInList: React.FC<INoDataInList> = ({
  heading,
  description,
}) => {
  return (
    <div className='flex items-center justify-center w-full'>
      <div className='text-center'>
        <p className='text-sm text-gray-500 font-medium'>{ heading }</p>
        <p className='text-xs text-gray-400 mt-1'>{ description }</p>
      </div>
    </div>
  );
};

export default NoDataInList;
